const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the user editor directive to manage edits on user objects
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('managerUserEditor', ['Application', 'Authorization', 'AdminUsers', 'Users', '$translate', function(Application, Authorization, AdminUsers, Users, $translate) {
    return {
      restrict: 'E',
      scope: {
        userId: '=',
        referenceUser: '=',
        managerConfiguration: '=',
        manager: '@?',
        onClose: '&?'
      },
      replace: true,
      template: require('../../../templates/directives/manager/manager-user-editor.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.unavailableChecked = true;
          self.userRecieved = false;
          self.showUserid = Authorization.getAuthToken() && Authorization.getAuthToken().company && Authorization.getAuthToken().company.show_userid || false;

          self.flags = Application.features.flags();
          self.creator = Application.access.user;

          self.company = Authorization.getAuthToken() && Authorization.getAuthToken().company || {};
          self.dateFormat = Application.dateFormatting.getStandardFormat();

          if (!$scope.managerConfiguration || !$scope.managerConfiguration.allow_user_edit) {
            Application.navigation.goTo('/explore');
            return;
          }

          var fields = ['name', 'email', 'userid', 'title', 'buddy', 'language', 'location', 'department', 'level', 'grade', 'groups', 'teams'];

          self.editableFields = {};
          var setList = $scope.managerConfiguration.restricted_user_edit ? $scope.managerConfiguration.restricted_editable_fields : fields;

          setList.forEach(function(item) {
            self.editableFields[item] = true;
          });

          $scope.referenceUser = {};
          self.loading = false;
          self.languages = Application.languages.getAvailable();
          self.editSaved = true;
          self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
          self.denied = false;
          self.signin_userid = Application.features.flags().signin_userid;
          self.signin_userid_copy = {field_name: 'User-ID'};
          if (self.signin_userid && Authorization.getAuthToken().company.signin_userid_copy) {
            self.signin_userid_copy = Authorization.getAuthToken().company.signin_userid_copy;
          }

          var locationChange = $scope.$on('$locationChangeStart', function(event) {
            if (self.editSaved) {
              // Allow the route change to progress
              self.denied = true;
              return;
            }

            // Halt the route change and question the action
            self.navigationPath = {};
            self.navigationPath.targetPath = Application.navigation.getPath();
            self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
            self.navigationPath.targetHash = Application.navigation.getHash();
            event.preventDefault();
            self.showDeparture = true;
            self.onLocationChange = function() {
              locationChange();
            };
          });

          self.buddyManager = {
            buddy_info: {},
            buddy_state: null,
            edit_buddy: false,
            buddy_choice: false,
            findBuddy: function() {
              if (!self.user || !self.user.buddy_email) {
                self.buddyManager.buddy_state = null;
                return;
              }
              if (self.user.buddy_email === this.buddy_info.email) {
                return;
              }
              Users.find({email: self.user.buddy_email, fields: 'first_name,last_name,full_name,email,image'}).$promise
              .then(function(users) {
                if (!users.length) {
                  self.buddyManager.buddy_state = 'email';
                  self.buddyManager.buddy_info.email = self.user.buddy_email;
                  return;
                }
                self.buddyManager.buddy_info = users[0];
                self.buddyManager.buddy_state = 'full';
              });
            },
            newBuddy: function() {
              this.buddy_choice = true;
              this.edit_buddy = false;
              self.user.buddy_email = '';
              self.buddyManager.findBuddy();
            },
            removeBuddy: function() {
              this.updateBuddy();
              this.edit_buddy = false;
            },
            updateBuddy: function(email) {
              var maintain = self.editSaved ? true : false;
              email = email ? email : '';
              Users.update({subresource: self.user._id, fields: 'first_name,last_name,email,userid,buddy_email'}, {buddy_email: email}).$promise
              .then(function(user) {
                self.user.buddy_email = email;
                self.buddyManager.findBuddy();
                Application.messaging.addMessage({type: 'success', text: self.translations['userEditor.buddy_has_been_updated'], duration: 5});
                setTimeout(function() {
                  self.editSaved = maintain;
                }, 50);
              });
            }
          };

          self.save = function() {
            self.loading = true;
            var body = {};

            Object.keys(self.editableFields).forEach(function(field) {
              switch (field) {
                case 'name':
                  body.first_name = self.user.first_name;
                  body.last_name = self.user.last_name;
                  return;
                case 'email':
                  body.email = self.user.email.toLowerCase();
                  return;
                case 'userid':
                  body.userid = self.user.userid;
                  return;
                case 'title':
                  body.job_title = self.user.job_title;
                  return;
                case 'language':
                  body.language = self.user.language;
                  return;
                case 'location':
                  body.linked_locations = self.user.linked_locations;
                  return;
                case 'department':
                  body.linked_departments = self.user.linked_departments;
                  return;
                case 'level':
                  body.linked_org_level = self.user.linked_org_level;
                  return;
                case 'grade':
                  body.linked_grade = self.user.linked_grade;
                  return;
                case 'groups':
                  body.groups = self.user.groups;
                  return;
                case 'teams':
                  body.linked_teams = self.user.linked_teams;
                  return;
              }
            });

            if ($scope.managerConfiguration.allow_adding_group_manager) {
              body.is_manager = self.user.is_manager;
              body.managing_groups = self.user.managing_groups;
            }


            Users.update({subresource: $scope.userId, fields: 'first_name,last_name,email,userid,job_title,job_type,role,office_location,language,image,department,last_login,notes,hired,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,is_collaborator,is_manager,manager_email,buddy_email,address,region,distributor,group,access_profile,managing_groups,manager_configuration'}, body, function(user) {
              user.formattedLastLogin = moment(user.last_login).format("MMM Do YY");
              self.user = user;
              $scope.referenceUser.is_manager = user.is_manager;
              $scope.referenceUser.is_collaborator = user.is_collaborator;
              $scope.referenceUser.email = user.email;
              $scope.referenceUser.userid = user.userid;
              $scope.referenceUser.full_name = user.full_name;
              $scope.referenceUser._id = user._id;
              Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.user_saved'], duration: 5});
              // setTimeout(function() {
                self.editSaved = true;
                $scope.onClose({results: user});
              // }, 100);
              self.loading = false;
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.user_couldNotBeSaved'], duration: 5});
            });
          };

          self.avatar = {
            image: '',
            active: false,
            loading: false,
            percent: null,
            image_name: '',
            modifiedLink: '',
            old: '',
            crop: function(link) {
              self.avatar.saveImage(link);
            },
            cancelCrop: function() {
              self.avatar.image = '';
              self.avatar.percent = null;
              self.avatar.loading = false;
              self.avatar.active = false;
              self.avatar.apply = false;
            },
            remove: function() {
              self.avatar.old = self.user.image;
              self.avatar.saveImage('');
            },
            progress: function() {
              if (this.percent === null) {
                return 0 + '';
              }
              return this.percent - 100 + '%';
            },
            saveImage: function(image) {
              var body = {image: image};
              Users.update({subresource: self.user._id, fields: 'first_name,last_name,email,image'}, body).$promise
                  .then(function(user) {
                    self.user.image = user.image;
                    Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['userEditor.image_saved']});
                    self.avatar.cancelCrop();
                  }).catch(function(error) {
              });
            }
          };

          $scope.$watch('editor.avatar.image', function(newVal, oldVal) {
            if (!newVal || newVal === oldVal) {
              return;
            }

            self.avatar.active = true;
          });

          self.initialize = function() {
            if (!$scope.userId) {
              Application.navigation.goTo('overview/users');
              return;
            }
            AdminUsers.get({subresource: $scope.userId, fields: 'first_name,last_name,email,userid,job_title,job_type,role,language,image,department,last_login,createdAt,notes,hired,linked_locations,linked_departments,is_collaborator,is_manager,manager_email,buddy_email,linked_teams,linked_org_level,linked_grade,address,country,distributor,region,group,access_profile,groups,managing_groups,manager_configuration'}).$promise
            .then(function(user) {

              if (!user || !user._id) {
                Application.navigation.goTo('/explore');
                return;
              }

              if (!user.groups) {
                user.groups = [];
              }

              user.formattedLastLogin = moment(user.last_login).format("MMM Do YY");
              self.user = user;
              if (!self.user.manager_configuration) {
                self.user.manager_configuration = {
                  disable_assignments: true,
                  allow_user_creation: false,
                  segmentation_required: [],
                  segmentation_subset: [],
                  hide_options: [],
                  allow_user_edit: false,
                  restricted_user_edit: false,
                  restricted_editable_fields: [],
                  allow_adding_group_manager: false,
                  disable_assignment_completion: true,
                  disable_assignment_removal: true
                };
              }

              $scope.referenceUser.is_manager = user.is_manager;
              $scope.referenceUser.is_collaborator = user.is_collaborator;
              $scope.referenceUser.email = user.email;
              $scope.referenceUser.userid = user.userid;
              $scope.referenceUser.full_name = user.full_name;
              $scope.referenceUser._id = user._id;

              self.buddyManager.findBuddy();
              self.originalUser = JSON.parse(JSON.stringify(user));
              if (!self.user.job_type) {
                self.user.job_type = 'SV';
              }

              if (!self.user.language) {
                self.user.language = self.languages[0].value;
              }

              self.newHire = false;
              if (self.user.hired) {
                var newDate = moment().subtract(90, 'days');
                var hiredOn = moment(self.user.hired, 'YYYY-MM-DD');
                if (moment.max(newDate, hiredOn).format('MM/DD/YY') === hiredOn.format('MM/DD/YY')) {
                  self.newHire = true;
                }
                self.hired = hiredOn.format('MM/DD/YY') !== '01/01/70' ? hiredOn.format('MM/DD/YY') : '';
                self.originalHired = self.hired.slice(0);
              }
              self.inactive = false;
              if (self.user.last_login) {
                var newInactive = moment().subtract(30, 'days');
                var ll = moment(new Date(self.user.last_login));
                if (moment.max(newInactive, ll).format('MM/DD/YY') === newInactive.format('MM/DD/YY')) {
                  self.inactive = true;
                }
              }
              self.lastLogin = self.user.last_login ? moment(new Date(self.user.last_login)).format('MMMM Do YYYY') : '----';
              self.created = self.user.createdAt ? moment(new Date(self.user.createdAt)).format('MMMM Do YYYY') : '----';
              self.startEditWatch();
            
              self.initComplete = true;
              self.userRecieved = true;
            });
          };


          self.startEditWatch = function() {
            $scope.$watch('editor.user', function(newVal, oldVal) {
              if (!newVal || newVal === oldVal) {
                return;
              }
              self.editSaved = false;
            }, true);
          };

          var langTranslations = self.languages.map(function(item) {
            return item.name;
          });

          $translate([
            'modules.notifications.invalidUrl',
            'modules.notifications.user_couldNotBeSaved',
            'modules.notifications.user_saved',
            'manage.users.creator',
            'manage.users.external',
            'manage.users.administrator',
            'manage.users.user',
            'manage.users.department',
            'manage.users.location',
            'manage.users.selectALocation',
            'userEditor.manager_has_been_updated',
            'userEditor.image_saved',
            'userEditor.buddy_has_been_updated'
          ].concat(langTranslations)).then(function(data) {
            self.translations = data;
            self.languages = self.languages.map(function(item) {
              if (data[item.name]) {
                item.name = data[item.name];
              }
              return item;
            });

            self.initialize();
          });

        }],
      controllerAs: 'editor'
    };
  }]);
